import { useEffect } from 'react';

import { useUrlStateV2 } from 'hooks';
import { loaders, mutations } from 'entities';

import { navigateToLogin, useAuth } from 'providers/Auth';
import { trackRegistration } from 'providers/Tracking';

import { Column, Skeleton } from 'components/Blocks';
import { LogoBubble, SiteTextLogo } from 'components/Logos';

import { shouldClearSession } from './utils';

export function ExchangeCode() {
  const { finishLogin } = useAuth();

  const [{ code, ...params }] = useUrlStateV2({
    code: '',
  });

  const purgeSession = mutations.auth.purgeSession.use({
    onSuccess: navigateToLogin,
  });

  useEffect(() => {
    if (code) return;

    // Prevents infinite redirects
    if (!shouldClearSession()) return navigateToLogin();

    purgeSession.execute();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  loaders.auth.loginWithCode.use({
    disabled: !code,

    params: { code },

    onLoad: (data) => {
      trackRegistration(data.user, params);

      finishLogin(data);
    },

    onError: navigateToLogin,
  });

  return (
    <div className="flex h-full small_tablet:flex-col">
      <Column className="bg-primary p-3 small_tablet:flex-row">
        <Skeleton className="size-9" />
        <Skeleton className="size-9" />
        <Skeleton className="size-9" />
      </Column>

      <Column className="h-full w-full max-w-[440px] flex-shrink-[1.5] items-center border-r border-r-primary-light/40 py-10 small_tablet:hidden">
        <LogoBubble />

        <Skeleton height={26} width={180} className="bg-primary/10" />
      </Column>

      <Column className="w-full items-center px-5 py-6">
        <SiteTextLogo className="mx-auto mb-2 mt-4" />

        <div className="mx-auto mt-4 grid w-full max-w-[1440px] grid-cols-3 gap-4 small_tablet:grid-cols-2 phone:grid-cols-1">
          <Skeleton
            quantity={6}
            wrapMultiple={false}
            height={144}
            width="100%"
            className="bg-primary/10"
          />
        </div>
      </Column>
    </div>
  );
}
